import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { Router } from '@angular/router';
import { ModalService } from '@app/shared/modal.service';
import { BalanceService } from '@app/core/balance.service';

@Injectable()
export class SmartAlertService {
  constructor(
    private modalService: ModalService,
    private auth: AuthenticationService,
    private router: Router,
    private balance: BalanceService
  ) {}

  /**
   * @param {Error} error
   */
  public showAlertFromError(error: Error): void {
    if (error.name === 'verify_account') {
      const title = 'Verification needed!';
      let text = 'Only verified users can play using real EDG tokens. Please complete your verification:';
      let ok = 'Upload documents';
      let action = () => {
        this.router.navigate(['/signup']);
      };

      if (this.auth.isVerificationPending()) {
        text =
          'Your verification is pending to be completed, please wait couple of minutes before playing in real mode.';
        ok = 'Ok';
        action = () => {};
      } else if (this.auth.isVerificationDeclined()) {
        text = 'Only verified users can play using real EDG tokens and your verification was declined.';
        ok = 'Ok';
        if (this.balance.getCurrentBalance() >= 0) {
          text =
            'Your verification was declined, contact support for further information or withdraw your deposited EDG tokens.';
          ok = 'Withdraw';
          action = () => {
            this.router.navigate(['/account/withdraw']);
          };
        }
      }
      this.modalService
        .openAlert(
          {
            title,
            text,
            ok,
          },
          false
        )
        .result.then(() => {
          action();
        })
        .catch(() => {});
    } else if (error.name === 'signature_error') {
      this.modalService.openSignatureAlert();
    } else {
      this.modalService
        .openAlert(
          {
            title: 'Alert',
            text: error.message,
          },
          false
        )
        .result.catch(() => {});
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/smart-alert.service.ts